import React, { useEffect, useRef, useState } from 'react';

/* ── Scroll-reveal wrapper ─────────────────────────────────────────────────── */
export const Reveal = ({ children, className = '', delay = 0 }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.unobserve(el); } },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.unobserve(el);
  }, []);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

/* ── Gradient page hero banner ─────────────────────────────────────────────── */
export const PageHero = ({ title, subtitle, children }) => (
  <section className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0a1628 0%, #0f2447 40%, #0c3d6b 70%, #0e4a7a 100%)' }}>
    <div className="absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} />
    <div className="absolute -top-24 -right-24 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" />
    <div className="absolute -bottom-32 -left-20 w-80 h-80 bg-blue-400/8 rounded-full blur-3xl" />
    <div className="relative max-w-5xl mx-auto px-6 py-12 md:py-16 text-center">
      <Reveal>
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white leading-tight tracking-tight">
          {title}
        </h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={120}>
          <p className="mt-4 text-base sm:text-lg text-blue-100/80 leading-relaxed max-w-2xl mx-auto">
            {subtitle}
          </p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);
